import * as React from 'react';

import classNames from 'classnames';
import type { ISizeModifier } from '../SizeHelper';
import { getSizeModifierClasses } from '../SizeHelper';

interface IIconProps extends ISizeModifier {
	placement?: 'left' | 'right';
	className?: string;
	isHidden?: boolean;
	onClick?: () => void;
}

export default class Icon extends React.Component<IIconProps, {}> {
	public render() {
		const { className, placement, isHidden, onClick } = this.props;

		if (isHidden) {
			return null;
		}

		const classes = classNames(
			'icon',
			getSizeModifierClasses(this.props),
			placement && `is-${placement}`,
			className && className
		);

		return (
			<span className={classes} onClick={onClick}>
				{this.props.children}
			</span>
		);
	}
}
